export default "/assets/images/purely-white.webp?878eddcaca2274773cb7b271da0c314c";